<google-map id="map"
            [mapId]="GOOGLE_MAP_ID"
            [center]="center"
            [zoom]="zoom"
            [options]="{
              mapTypeControl: false
            }"
            height="100%"
            width="100%"
            (mapClick)="onMapClick()"
            (mapDrag)="onMapClick()">

  @for (marker of markers; track marker.place._id!) {
    <map-advanced-marker
      #markerElem="mapAdvancedMarker"
      [title]="marker.place.name"
      [position]="{lat: marker.latitude, lng: marker.longitude}"
      [content]="marker.content"
      [options]="{gmpClickable: true}"
      (mapClick)="onMarkerClick(markerElem, marker.place, marker.rooms)">
    </map-advanced-marker>

    <map-info-window #mapInfoWindow [options]="{headerDisabled: true, maxWidth: 300}">
      <div *ngIf="place">
        <div class="text-center"><span style="font-weight: 500; font-size: 16px">{{ place.name! }}</span></div>
        <div class="text-center"><small>{{ place.location!.neighborhood! }}</small></div>
        <br/>
      </div>
      <app-room-rectangle [room]="room" *ngFor="let room of rooms"/>
    </map-info-window>
  }

</google-map>
